let pending = null;
let revision = 0;
export default {
  namespaced: true,
  state: {
    mode: null, readOnlySince: null, generation: null, exportsVisible: false, loadFailed: false,
  },
  getters: {
    canWrite: state => state.mode === `writable`,
    isReadOnly: state => state.mode === `readOnly`,
  },
  mutations: {
    SET_STATE(state, value) {
      Object.assign(state, value);
      if (value.mode === `writable` || value.mode === `readOnly`) state.loadFailed = false;
    },
  },
  actions: {
    refresh({ commit }) {
      if (!pending) {
        const requestedRevision = revision;
        // Load after store initialization; use a literal for the legacy ESLint parser.
        // eslint-disable-next-line quotes, import/no-cycle
        pending = import('@/api').then(({ default: api }) => api.get(`/platform-state`)).then(({ data }) => {
          if (requestedRevision === revision) commit(`SET_STATE`, data);
        }).catch(() => {
          if (requestedRevision === revision) commit(`SET_STATE`, { mode: null, loadFailed: true });
        }).finally(() => { pending = null; });
      }
      return pending;
    },
    async setExportsVisible({ commit }, exportsVisible) {
      revision += 1;
      // eslint-disable-next-line quotes, import/no-cycle
      const { default: api } = await import('@/api');
      const { data } = await api.put(`/platform-state/exports-visibility`, { exportsVisible });
      commit(`SET_STATE`, data);
    },
    async setReadOnly({ commit }, readOnly) {
      revision += 1;
      // eslint-disable-next-line quotes, import/no-cycle
      const { default: api } = await import('@/api');
      const { data } = await api.put(`/platform-state/read-only`, { readOnly });
      commit(`SET_STATE`, data);
    },
  },
};
